import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { 
  IAnalistaListRequest, 
  IAnalistaListResponse, 
  IAnalistaDeleteRequest, 
  IAnalistaDeleteResponse,
  IAnalistaAddRequest,
  IAnalistaAddResponse,
  IAnalistaDetailRequest,
  IAnalistaDetailResponse,
  IAnalistaUpdateRequest,
  IAnalistaUpdateResponse,
  IUsuarioDropdownRequest,
  IUsuarioDropdownResponse
} from '../interfaces/analistas.interface';

@Injectable({
  providedIn: 'root'
})
export class AnalistasService {
  constructor(private http: HttpClient) { }

  getAnalistasList(payload: IAnalistaListRequest): Observable<IAnalistaListResponse> {
    return this.http.post<IAnalistaListResponse>(`${environment.apiNewBackBaseUrl}OpcionesSolicitud/GetAnalista`, payload);
  }

  deleteAnalista(clave_analista: string): Observable<IAnalistaDeleteResponse> {
    const payload: IAnalistaDeleteRequest = {
      que: 3,
      tope: '',
      cmd: '',
      clave_analista: clave_analista,
      nombre_analista: ''
    };
    return this.http.post<IAnalistaDeleteResponse>(`${environment.apiNewBackBaseUrl}Analistas/sospa_analistasDelete`, payload);
  }

  getUsuariosDropdown(payload: IUsuarioDropdownRequest): Observable<IUsuarioDropdownResponse> {
    return this.http.post<IUsuarioDropdownResponse>(`${environment.apiNewBackBaseUrl}UsuarsCS/Getcmspa_usua4V2`, payload);
  }

  addAnalista(payload: IAnalistaAddRequest): Observable<IAnalistaAddResponse> {
    return this.http.post<IAnalistaAddResponse>(`${environment.apiNewBackBaseUrl}Analistas/sospa_analistasAdd`, payload);
  }

  getAnalistaDetail(payload: IAnalistaDetailRequest): Observable<IAnalistaDetailResponse> {
    return this.http.post<IAnalistaDetailResponse>(`${environment.apiNewBackBaseUrl}Analistas/sospa_analistasListDet`, payload);
  }

  updateAnalista(payload: IAnalistaUpdateRequest): Observable<IAnalistaUpdateResponse> {
    return this.http.post<IAnalistaUpdateResponse>(`${environment.apiNewBackBaseUrl}Analistas/sospa_analistasUpd`, payload);
  }
} 